import {
  DashboardAdvanceInput,
  DashboardDivisor,
  DashboardhMediumButton,
  Icon,
} from 'bd-web-components'
import {
  AdvanceDesktopBox,
  AdvanceIconBox,
  DesktopContainer,
  DesktopInputBox,
  AdvanceControlsDesktopBox,
  SimulationDesktopBox,
  TermsAndConditionText,
  TermsAndConditionLabel,
  TermsAndConditionLink,
  AvaliableValueText,
  AvaliableValueTextBold,
  ErrorMessage,
  InlineTextDiv,
  TermsAndConditionInput,
  TermsAndConditionTextBox,
} from './advance-style'
import {
  GRAY_SCALE_08,
  PRIMARY_RED_01,
  SECONDARY_BLUE_01,
  WHITE,
} from 'bd-web-components/src/utils/dash-colors'
import Loader from '../../components/Loader'
import { getDashColor } from '../../styles'
export const AdvanceDesktop = ({
  useFormikProps,
  advanceLimitFormatted,
  isError,
  isSimulation,
  priceOfAdvance,
  advanceTariff,
  disabledControl,
  loading,
  setIsSimulation,
  disabledAdvanceControl,
  setIsTermModal,
}: any) => {
  return (
    <DesktopContainer>
      <AdvanceDesktopBox>
        <DesktopInputBox>
          <DashboardAdvanceInput
            type={'text'}
            error={isError}
            name={'totalAdvancedRequested'}
            title={'Antecipar'}
            value={useFormikProps.values.totalAdvancedRequested}
            onChange={(e: any) => {
              useFormikProps.setFieldValue(
                'totalAdvancedRequested',
                e.target.value
              )
            }}
            onBlur={useFormikProps.handleBlur}
            placeholder={'000'}
            disabled={!isSimulation}
          />
          <DashboardDivisor
            marginTop={29}
            marginBottom={19}
            marginTopMobile={8}
            marginBottomMobile={16}
            color={GRAY_SCALE_08}
          />
          <ErrorMessage error={isError}>
            {useFormikProps.errors.totalAdvancedRequested}
          </ErrorMessage>
          <InlineTextDiv>
            <AvaliableValueText>Valor disponível:</AvaliableValueText>
            <AvaliableValueTextBold>
              {advanceLimitFormatted}
            </AvaliableValueTextBold>
          </InlineTextDiv>
        </DesktopInputBox>
        <AdvanceIconBox>
          <div
            className="iconbox-advance"
            style={{
              width: '42px',
              height: '42px',
            }}
          >
            <Icon
              width={42}
              height={42}
              iconName={'twoSidesArrow'}
              fill={isError ? PRIMARY_RED_01 : getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')}
              classes="twoSidesArrow"
            />
          </div>
        </AdvanceIconBox>
        <DesktopInputBox>
          <DashboardAdvanceInput
            type={'text'}
            error={false}
            name={'requestValue'}
            title={'Valor a receber'}
            placeholder={'0,00'}
            onChange={() => { }}
            value={useFormikProps.values.totalAdvanced}
            disabled={true}
          />
          <DashboardDivisor
            marginTop={29}
            marginBottom={19}
            marginTopMobile={29}
            marginBottomMobile={19}
            color={GRAY_SCALE_08}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'row',
              width: '100%',
            }}
          >
            <InlineTextDiv>
              <AvaliableValueText>Taxa Efetiva:</AvaliableValueText>
              <AvaliableValueTextBold>{advanceTariff}</AvaliableValueTextBold>
            </InlineTextDiv>
            <InlineTextDiv>
              <AvaliableValueText>Custo:</AvaliableValueText>
              <AvaliableValueTextBold>{priceOfAdvance}</AvaliableValueTextBold>
            </InlineTextDiv>
          </div>
        </DesktopInputBox>
      </AdvanceDesktopBox>
      <AdvanceControlsDesktopBox>
        <TermsAndConditionLabel>
          <TermsAndConditionInput
            type="checkbox"
            name="termsAndConditions"
            checked={useFormikProps.values.termsAndConditions}
            onChange={useFormikProps.handleChange}
          />
          <TermsAndConditionTextBox>
            <TermsAndConditionText>
              Li e aceito os{' '}
              <TermsAndConditionLink onClick={() => setIsTermModal(true)}>
                termos e condições{' '}
              </TermsAndConditionLink>{' '}
              da antecipação de saldo.{' '}
            </TermsAndConditionText>
          </TermsAndConditionTextBox>
        </TermsAndConditionLabel>
        {isSimulation && (
          <SimulationDesktopBox className={'advance-button-simulation-box'}>
            <DashboardhMediumButton
              type="submit"
              background={disabledControl && !loading ? getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR') : ''}
              color={disabledControl && !loading ? WHITE : ''}
              height="52px"
              width="140px"
              maxWidth="100%"
              variant={disabledControl && !loading ? 'outlined' : 'disabled'}
              borderRadius='100px'
            >
              {!loading && <>{'Simular'}</>}
              {loading && <Loader small={true} />}
            </DashboardhMediumButton>
          </SimulationDesktopBox>
        )}
        {!isSimulation && (
          <SimulationDesktopBox className={'advance-button-advance-box'}>
            <DashboardhMediumButton
              onClick={() => {
                useFormikProps.resetForm()
                setIsSimulation(true)
              }}
              type="submit"
              height="52px"
              width="140px"
              maxWidth="438px"
              variant={'outlined'}
              borderRadius='100px'
            >
              {'Limpar'}
            </DashboardhMediumButton>
            <DashboardhMediumButton
              type="submit"
              background={disabledAdvanceControl ? SECONDARY_BLUE_01 : ''}
              color={disabledAdvanceControl ? WHITE : ''}
              height="52px"
              width="140px"
              maxWidth="438px"
              variant={disabledAdvanceControl ? 'outlined' : 'disabled'}
              borderRadius='100px'
            >
              {!loading && <>{'Antecipar'}</>}
              {loading && <Loader small={true} />}
            </DashboardhMediumButton>
          </SimulationDesktopBox>
        )}
      </AdvanceControlsDesktopBox>
    </DesktopContainer>
  )
}
